/**
 * Where Zotero or Mendeley sends you back after signing in. In the sign-in window it reports to
 * the BrainLog tab that opened it and closes; opened on its own, it shows the result.
 */
import { useEffect } from "react";
import { CircleAlert, CircleCheck } from "lucide-react";
import { APP_NAME } from "@brainlog/shared";
import { Button } from "@/components/ui/button";

export function RefManDonePage() {
  const params = new URLSearchParams(window.location.search);
  const ok = params.get("status") === "ok";
  const message = params.get("message") ?? (ok ? "Connected." : "The connection did not finish.");
  useEffect(() => {
    if (!window.opener) return;
    try {
      window.opener.postMessage({ type: "brainlog-refman", status: ok ? "ok" : "error", message, provider: params.get("provider") }, window.location.origin);
      window.close();
    } catch {
      // The opener is gone: this page stays open with the result.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="flex min-h-full items-center justify-center bg-background p-4">
      <main className="w-full max-w-md space-y-4 rounded-xl border bg-card p-6 shadow-sm">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{APP_NAME}</p>
        <h1 className="flex items-center gap-2 font-display text-xl font-semibold">
          {ok ? <CircleCheck className="size-5 text-success" aria-hidden /> : <CircleAlert className="size-5 text-destructive" aria-hidden />}
          {ok ? "Connected" : "Not connected"}
        </h1>
        <p className="text-sm" role="status">
          {message}
        </p>
        <Button onClick={() => (window.location.href = "/")}>Back to {APP_NAME}</Button>
      </main>
    </div>
  );
}
